import React from "react";
import { useParams } from "react-router-dom";

import UnifiedRegistry from ".";

interface RegistryFolderViewProps {
  onItemClick?: (item: import("./types").RegistryItem) => void;
}

const RegistryFolderView: React.FC<RegistryFolderViewProps> = ({ onItemClick }) => {
  const { folderId } = useParams<{ folderId: string }>();

  // Parse folderId to number, handle cases where it might be undefined or invalid
  const currentFolderId = folderId ? parseInt(folderId, 10) : undefined;

  // If folderId is invalid (NaN), we'll treat it as root level
  const validFolderId = currentFolderId && !isNaN(currentFolderId) ? currentFolderId : undefined;

  return <UnifiedRegistry currentFolderId={validFolderId ?? null} onItemClick={onItemClick} />;
};

export default RegistryFolderView;
